import {
	EmblaBase,
	EmblaWrapperConstructorType,
} from '@/scripts/theme/embla-base'

export class AnnouncementBar extends EmblaBase {
	static override htmlSelector = 'announcement-bar'
	constructor() {
		super()
	}
	override getOptions(): EmblaWrapperConstructorType {
		const customOptions = this.getCustomOptions()
		return {
			userOptions: { loop: true, inViewThreshold: 1, align: 'start' },
			enabledPlugins: {
				autoPlay: true,
				wheelGestures: true,
				classNames: true,
			},
			customOptions,
		}
	}
}
